<template>
  <section
    class="fullscreen-section intro-section"
    ref="section"
  >
    <!-- 콘텐츠 -->
    <div class="content-wrapper">
      <!-- 왼쪽: 타이틀 + 설명 + 탭 -->
      <div class="left-content">
        <transition name="slide-up" mode="out-in">
          <div class="title-area" :key="'title-' + activeFeature">
            <p class="script-title">{{ features[activeFeature].scriptTitle }}</p>
            <h2 class="main-title" v-html="features[activeFeature].mainTitle.replace('\n', '<br/>')"></h2>
          </div>
        </transition>

        <transition name="slide-up" mode="out-in">
          <div class="feature-info" :key="activeFeature">
            <h3 class="feature-title">{{ features[activeFeature].title }}</h3>
            <p class="feature-desc">{{ features[activeFeature].desc }}</p>
          </div>
        </transition>

        <!-- 하단 탭 네비게이션 -->
        <div class="tab-nav">
          <div
            class="tab-item"
            v-for="(feature, index) in features"
            :key="index"
            :class="{ active: activeFeature === index }"
            @click="setActiveFeature(index)"
          >
            <span class="tab-num">{{ String(index + 1).padStart(2, '0') }}</span>
            <div class="tab-line"></div>
            <p class="tab-label">{{ feature.label }}</p>
          </div>
        </div>
      </div>

      <!-- 오른쪽: 이미지 + 애니메이션 라인 -->
      <div class="right-content">
        <div class="image-container">
          <!-- 애니메이션 라인들 -->
          <div class="border-lines">
            <div class="line line-top"></div>
            <div class="line line-right"></div>
            <div class="line line-bottom"></div>
            <div class="line line-left"></div>
          </div>
          <!-- 코너 장식 -->
          <div class="corner corner-tl"></div>
          <div class="corner corner-tr"></div>
          <div class="corner corner-bl"></div>
          <div class="corner corner-br"></div>
          <!-- 이미지 -->
          <div class="image-wrapper">
            <transition name="fade" mode="out-in">
              <img
                :key="activeFeature"
                :src="features[activeFeature].image"
                :alt="features[activeFeature].title"
              />
            </transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'IntroSection',
  data() {
    return {
      activeFeature: 0,
      isTransitioning: false,
      transitionTimeout: null,
      features: [
        {
          scriptTitle: 'Expansion City',
          mainTitle: 'NEW\nCITY',
          title: '확장신도시',
          desc: '적동·인덕·옥계지구가 하나로 연결되는 구미 최대 신도시권',
          label: '확장신도시',
          image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920&q=80'
        },
        {
          scriptTitle: 'High-Tech Valley',
          mainTitle: 'HIGH\nTECH',
          title: '하이테크밸리',
          desc: 'AI·반도체 산업 집중 육성, 5공단 첨단산업 클러스터',
          label: '하이테크밸리',
          image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1920&q=80'
        },
        {
          scriptTitle: 'Semiconductor',
          mainTitle: 'SEMI\nCONDUCTOR',
          title: '반도체특화',
          desc: '2조원 규모 AI 데이터센터·수소연료전지 발전소 투자 확정',
          label: '반도체특화',
          image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1920&q=80'
        }
      ]
    }
  },
  beforeUnmount() {
    if (this.transitionTimeout) {
      clearTimeout(this.transitionTimeout)
    }
  },
  methods: {
    setActiveFeature(index) {
      if (this.isTransitioning) return
      this.activeFeature = index
    },
    handleScroll(direction) {
      if (this.isTransitioning) return true

      if (direction > 0) {
        if (this.activeFeature < this.features.length - 1) {
          this.isTransitioning = true
          this.activeFeature++
          this.transitionTimeout = setTimeout(() => {
            this.isTransitioning = false
          }, 800)
          return true
        } else {
          return false
        }
      } else {
        if (this.activeFeature > 0) {
          this.isTransitioning = true
          this.activeFeature--
          this.transitionTimeout = setTimeout(() => {
            this.isTransitioning = false
          }, 800)
          return true
        } else {
          return false
        }
      }
    },
    getSection() {
      return this.$refs.section
    },
    resetToFirst() {
      this.activeFeature = 0
    },
    setToLast() {
      this.activeFeature = this.features.length - 1
      this.isTransitioning = true
      setTimeout(() => {
        this.isTransitioning = false
      }, 300)
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Pinyon+Script&display=swap');

.fullscreen-section {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: #fff;
}

/* 콘텐츠 */
.content-wrapper {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 100%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 60px;
  gap: 60px;
}

/* 왼쪽 콘텐츠 */
.left-content {
  flex: 1;
  max-width: 550px;
  transition: transform 0.5s ease-out;
}

.title-area {
  margin-bottom: 50px;
}

.script-title {
  font-family: 'Pinyon Script', cursive;
  font-size: 52px;
  color: #333;
  margin-bottom: 5px;
  font-weight: 400;
  line-height: 1;
}

.main-title {
  font-size: 72px;
  font-weight: 200;
  color: #1a1a1a;
  line-height: 0.95;
  letter-spacing: 8px;
  margin: 0;
}

.feature-info {
  border-left: 2px solid var(--main-color1);
  padding-left: 25px;
  margin-bottom: 40px;
}

.feature-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 10px;
  letter-spacing: -0.5px;
}

.feature-desc {
  font-size: 15px;
  color: #666;
  line-height: 1.7;
}

/* 하단 탭 네비게이션 */
.tab-nav {
  display: flex;
  gap: 30px;
}

.tab-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  opacity: 0.4;
  transition: all 0.4s ease;
  min-width: 100px;
}

.tab-item.active {
  opacity: 1;
}

.tab-item:hover {
  opacity: 0.8;
}

.tab-item.active:hover {
  opacity: 1;
}

.tab-num {
  font-size: 13px;
  font-weight: 600;
  color: var(--main-color1);
}

.tab-line {
  width: 100%;
  height: 2px;
  background: rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease;
}

.tab-item.active .tab-line {
  background: var(--main-color1);
}

.tab-label {
  font-size: 11px;
  font-weight: 600;
  color: #333;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0;
}

/* 오른쪽 이미지 영역 */
.right-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 550px;
}

.image-container {
  position: relative;
  width: 100%;
  aspect-ratio: 3/4;
  max-height: 70vh;
}

/* 애니메이션 라인들 */
.border-lines {
  position: absolute;
  top: -15px;
  left: -15px;
  right: -15px;
  bottom: -15px;
  pointer-events: none;
}

.line {
  position: absolute;
  background: var(--main-color1);
}

.line-top {
  top: 0;
  left: 0;
  height: 1px;
  width: 0;
  animation: lineTop 3s ease-in-out infinite;
}

.line-right {
  top: 0;
  right: 0;
  width: 1px;
  height: 0;
  animation: lineRight 3s ease-in-out infinite;
  animation-delay: 0.75s;
}

.line-bottom {
  bottom: 0;
  right: 0;
  height: 1px;
  width: 0;
  animation: lineBottom 3s ease-in-out infinite;
  animation-delay: 1.5s;
}

.line-left {
  bottom: 0;
  left: 0;
  width: 1px;
  height: 0;
  animation: lineLeft 3s ease-in-out infinite;
  animation-delay: 2.25s;
}

@keyframes lineTop {
  0%, 100% { width: 0; left: 0; opacity: 0; }
  10% { opacity: 1; }
  50% { width: 100%; left: 0; opacity: 1; }
  90% { opacity: 1; }
  95% { width: 100%; left: 0; opacity: 0; }
}

@keyframes lineRight {
  0%, 100% { height: 0; top: 0; opacity: 0; }
  10% { opacity: 1; }
  50% { height: 100%; top: 0; opacity: 1; }
  90% { opacity: 1; }
  95% { height: 100%; top: 0; opacity: 0; }
}

@keyframes lineBottom {
  0%, 100% { width: 0; right: 0; opacity: 0; }
  10% { opacity: 1; }
  50% { width: 100%; right: 0; opacity: 1; }
  90% { opacity: 1; }
  95% { width: 100%; right: 0; opacity: 0; }
}

@keyframes lineLeft {
  0%, 100% { height: 0; bottom: 0; opacity: 0; }
  10% { opacity: 1; }
  50% { height: 100%; bottom: 0; opacity: 1; }
  90% { opacity: 1; }
  95% { height: 100%; bottom: 0; opacity: 0; }
}

/* 코너 장식 */
.corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border-color: rgba(0, 0, 0, 0.2);
  border-style: solid;
  border-width: 0;
}

.corner-tl {
  top: -15px;
  left: -15px;
  border-top-width: 1px;
  border-left-width: 1px;
}

.corner-tr {
  top: -15px;
  right: -15px;
  border-top-width: 1px;
  border-right-width: 1px;
}

.corner-bl {
  bottom: -15px;
  left: -15px;
  border-bottom-width: 1px;
  border-left-width: 1px;
}

.corner-br {
  bottom: -15px;
  right: -15px;
  border-bottom-width: 1px;
  border-right-width: 1px;
}

/* 이미지 */
.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease-out;
}

/* 트랜지션 */
.slide-up-enter-active {
  transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-up-leave-active {
  transition: all 0.4s ease;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}

.fade-enter-active {
  transition: opacity 0.8s ease;
}

.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 반응형 */
@media (max-width: 1400px) {
  .content-wrapper {
    padding: 0 60px;
    gap: 60px;
  }
  .main-title {
    font-size: 60px;
    letter-spacing: 6px;
  }
  .script-title {
    font-size: 46px;
  }
  .feature-title {
    font-size: 24px;
  }
  .right-content {
    max-width: 450px;
  }
}

@media (max-width: 1200px) {
  .main-title {
    font-size: 52px;
  }
  .script-title {
    font-size: 40px;
  }
  .feature-title {
    font-size: 22px;
  }
  .feature-desc {
    font-size: 15px;
  }
  .right-content {
    max-width: 400px;
  }
}

@media (max-width: 1024px) {
  .content-wrapper {
    flex-direction: column;
    justify-content: center;
    padding: 80px 40px;
    gap: 40px;
  }
  .left-content {
    text-align: center;
    max-width: 100%;
  }
  .title-area {
    margin-bottom: 30px;
  }
  .main-title {
    font-size: 46px;
  }
  .script-title {
    font-size: 36px;
  }
  .feature-info {
    border-left: none;
    padding-left: 0;
    border-top: 2px solid var(--main-color1);
    padding-top: 20px;
    margin-bottom: 30px;
  }
  .tab-nav {
    justify-content: center;
  }
  .right-content {
    max-width: 350px;
    width: 100%;
  }
  .image-container {
    max-height: 40vh;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 60px 24px;
  }
  .main-title {
    font-size: 38px;
    letter-spacing: 4px;
  }
  .script-title {
    font-size: 30px;
  }
  .feature-title {
    font-size: 20px;
  }
  .feature-desc {
    font-size: 14px;
  }
  .tab-nav {
    gap: 20px;
  }
  .tab-item {
    min-width: 80px;
  }
  .right-content {
    max-width: 300px;
  }
  .scroll-hint {
    display: none;
  }
  .border-lines {
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
  }
  .corner {
    width: 15px;
    height: 15px;
  }
  .corner-tl { top: -10px; left: -10px; }
  .corner-tr { top: -10px; right: -10px; }
  .corner-bl { bottom: -10px; left: -10px; }
  .corner-br { bottom: -10px; right: -10px; }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 30px;
  }
  .script-title {
    font-size: 26px;
  }
  .tab-item {
    min-width: 70px;
  }
  .tab-label {
    font-size: 10px;
  }
}
</style>
